/**
 * Конфигурация подключения к бекенду
 */

// API Base URLs
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';
export const WEBSOCKET_URL = process.env.REACT_APP_WEBSOCKET_URL || 'http://localhost:3001';

// API Endpoints
export const ENDPOINTS = {
  // Support Chat
  SUPPORT_MESSAGES: '/support/messages',
  SUPPORT_ORDER_MESSAGES: (orderId) => `/support/orders/${orderId}/messages`,
  SUPPORT_ORDER: (orderId) => `/support/orders/${orderId}`,
  SUPPORT_RECENT_CHATS: '/support/chats/recent',
  
  // Orders
  ORDERS: '/orders',
  ORDER_BY_ID: (orderId) => `/orders/${orderId}`,
  ORDER_TARIFF: (orderId) => `/orders/${orderId}/tariff`,
  ORDER_STATUS: (orderId) => `/orders/${orderId}/status`,
  ORDER_STATS: '/orders/admin/stats',
  
  // Authentication
  AUTH_LOGIN: '/auth/login',
  AUTH_ME: '/auth/me',
  
  // Promo Codes
  PROMO_VALIDATE: '/promo/validate',
  
  // Visits Tracking
  VISITS_NOTIFY: '/visits/notify',
};

// WebSocket Events
export const WS_EVENTS = {
  // User events
  USER_JOIN: 'user:join',
  USER_MESSAGE: 'user:message',
  CHAT_JOINED: 'chat:joined',
  MESSAGE_SENT: 'message:sent',
  AGENT_MESSAGE: 'agent:message',
  
  // Agent events
  AGENT_AUTHENTICATE: 'agent:authenticate',
  AGENT_JOIN_ORDER: 'agent:join-order',
  AUTH_SUCCESS: 'auth:success',
  AUTH_ERROR: 'auth:error',
  ORDER_JOINED: 'order:joined',
  CHATS_RECENT: 'chats:recent',
  USER_JOINED: 'user:joined',
  USER_LEFT: 'user:left',
  
  // Error events
  ERROR: 'error',
  CONNECT_ERROR: 'connect_error',
};

// Request configuration
export const REQUEST_CONFIG = {
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 10000, // 10 seconds
};

// Chat configuration
export const CHAT_CONFIG = {
  reconnectionAttempts: 5,
  reconnectionDelay: 1000,
  autoConnect: true,
};
